import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import {
  Button,
  Box,
  Typography
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';

const GoogleSignInButton = ({ onSuccess, onError, disabled = false, variant = 'contained', size = 'large' }) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log('Google login success:', tokenResponse);
      if (onSuccess) {
        onSuccess(tokenResponse);
      }
    },
    onError: (error) => {
      console.error('Google login error:', error);
      if (onError) {
        onError(error);
      }
    },
    flow: 'implicit',
    scope: 'openid email profile',
    // Add error handling for COOP issues
    onNonOAuthError: (error) => {
      console.error('Google non-OAuth error:', error);
      if (onError) {
        onError(error);
      }
    }
  });

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => login()}
      disabled={disabled}
      sx={{
        bgcolor: variant === 'contained' ? '#4285f4' : 'transparent',
        color: variant === 'contained' ? 'white' : '#4285f4',
        border: variant === 'outlined' ? '1px solid #4285f4' : 'none',
        '&:hover': {
          bgcolor: variant === 'contained' ? '#3367d6' : 'rgba(66, 133, 244, 0.04)',
        },
        '&:disabled': {
          bgcolor: variant === 'contained' ? 'rgba(66, 133, 244, 0.38)' : 'transparent',
          color: variant === 'contained' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(66, 133, 244, 0.38)',
        }
      }}
      fullWidth
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <GoogleIcon />
        <Typography variant="button">
          Continue with Google
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleSignInButton;